import { PATH_DASHBOARD } from '../../../routes/paths';
import SvgColor from 'components/svg-color';
import { NavSection } from 'components/nav-section/types';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: icon('ic_blog'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

const navConfig: NavSection[] = [
  {
    subheader: 'system',
    items: [
      { title: 'Quản lý Tài khoản', path: PATH_DASHBOARD.system.user, icon: ICONS.blank },
      { title: 'Quản lý Ngân hàng', path: PATH_DASHBOARD.system.bank, icon: ICONS.blank },
      { title: 'Quản lý Nhóm thành viên', path: PATH_DASHBOARD.system.loyal, icon: ICONS.blank },
      { title: 'Quản lý Khuyến mãi', path: PATH_DASHBOARD.system.topup, icon: ICONS.blank },
      { title: 'Quản lý Server', path: PATH_DASHBOARD.system.server, icon: ICONS.blank },
      { title: 'Quản lý Dịch vụ', path: PATH_DASHBOARD.system.service, icon: ICONS.blank },
      { title: 'Quản lý Gói bán', path: PATH_DASHBOARD.system.pack, icon: ICONS.blank },
      {
        title: 'Lịch sử',
        path: PATH_DASHBOARD.system.history.root,
        icon: ICONS.banking,
        children: [
          {
            title: 'Đơn hàng Seeding',
            path: PATH_DASHBOARD.system.history.orderseeding,
          },
          {
            title: 'Giao dịch',
            path: PATH_DASHBOARD.system.history.transaction,
          },
          { title: 'Ngân hàng', path: PATH_DASHBOARD.system.history.bank },
        ],
      },
    ],
  },
];

export default navConfig;
